import axiosClient from "@/libs/axiosClient";

export const removeFromGroup = (data) => {
    return axiosClient.post(`/table/rcm-edges/update/removefromgroup`, data);
};



// WEBPACK FOOTER //
// ./src/api/edge.js